import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { AlertList } from 'react-bs-notifier';

export const AlertasContext = React.createContext();

class AlertasProvider extends Component {
	constructor(props) {
		super(props);

		this.state = {
			alerts: [],
			info: this.info,
			success: this.success,
			warning: this.warning,
			error: this.error,
			limparAlertas: this.limparAlertas,
			setHoldState: this.setHoldState,
			setSingleAlertState: this.setSingleAlertState,
		};
	}

	info = msg => this.setState({ novoAlerta: { type: 'info', message: msg } });

	success = msg => this.setState({ novoAlerta: { type: 'success', message: msg } });

	warning = msg => this.setState({ novoAlerta: { type: 'warning', message: msg } });

	error = msg => this.setState({ novoAlerta: { type: 'danger', message: msg } });

	onDismissedAlert(alert) {
		let alerts = this.state.alerts;

		// find the index of the alert that was dismissed
		const idx = alerts.indexOf(alert);

		if (idx >= 0) {
			// remove the alert from the array
			alerts = [...alerts.slice(0, idx), ...alerts.slice(idx + 1)];
			this.setState({
				alerts: alerts,
			});
		}

		// caso a lista de alertas esteja vazia
		if (!alerts.length) {
			this.handleAlertasRemovidos();
		}
	}

	setHoldState = value => this.setState({ hold: value });

	setSingleAlertState = value => this.setState({ blSingleAlert: value });

	handleAlertaInserido() {
		this.setState({
			novoAlerta: null,
			blExistemAlertas: true,
		});
	}

	handleAlertasRemovidos() {
		this.setState({
			blExistemAlertas: false,
		});
	}

	limparAlertas = () => {
		this.setState({ alerts: [] });
		this.handleAlertasRemovidos();
	};

	componentDidUpdate() {
		const idUltimoAlerta = Math.max.apply(Math, this.state.alerts.map(item => item.id));
		const ultimoAlerta = this.state.alerts.find(alert => alert.id === idUltimoAlerta);
		const blUpdateLock = this.state.blUpdateLock;
		const blNovoAlerta = !!this.state.novoAlerta;
		const blUltimoAlertaOK =
			this.state.alerts.length === 0 ||
			(this.state.alerts.length === 1 && this.state.alerts.findIndex(x => x.id === idUltimoAlerta) > -1);

		if (!blUltimoAlertaOK && this.state.blSingleAlert) {
			this.setState({
				alerts: [ultimoAlerta],
			});
		}

		if (!blUpdateLock && blNovoAlerta) {
			const tipo = this.state.novoAlerta.type
				.replace('info', 'Informação')
				.replace('success', 'Sucesso')
				.replace('warning', 'Alerta')
				.replace('danger', 'Erro');

			const newAlert = {
				id: new Date().getTime(),
				type: this.state.novoAlerta.type,
				headline: tipo,
				message: this.state.novoAlerta.message,
			};
			if (this.state.blSingleAlert) {
				this.setState({
					alerts: [newAlert],
					blUpdateLock: true,
				});
			} else {
				this.setState({
					alerts: [...this.state.alerts, newAlert],
					blUpdateLock: true,
				});
			}

			this.handleAlertaInserido();
		}

		if (blUpdateLock && !blNovoAlerta) {
			this.setState({ blUpdateLock: false });
		}
	}

	render() {
		return (
			<AlertasContext.Provider value={this.state}>
				<AlertList
					position="top-right"
					alerts={this.state.alerts}
					timeout={this.state.hold ? 0 : 15000}
					dismissTitle="Fechar"
					onDismiss={this.onDismissedAlert.bind(this)}
				/>
				{this.props.children}
			</AlertasContext.Provider>
		);
	}
}

AlertasProvider.propTypes = {
	children: PropTypes.node.isRequired,
};

export default AlertasProvider;
